module.exports = __webpack_public_path__ + "img/level1_mining_tool_shadow-2.feec96ca.png";